"use strict";
'use strict';

var tabs = require('./tabs.cjs');



exports.Content = tabs.TabsContent;
exports.ContentGroup = tabs.TabsContentGroup;
exports.Context = tabs.TabsContext;
exports.Indicator = tabs.TabsIndicator;
exports.List = tabs.TabsList;
exports.PropsProvider = tabs.TabsPropsProvider;
exports.Root = tabs.TabsRoot;
exports.RootProvider = tabs.TabsRootProvider;
exports.Trigger = tabs.TabsTrigger;
